import { Box } from '@mui/material';
import React from 'react';
import { BackgroundErrorHeader } from '../BackgroundErrorHeader';
import { BackgroundErrorPanel } from '../BackgroundErrorPanel';
import bgImage from '@/assets/images/background.jpg';

export const PageNotFound = () => {
  return (
    <Box>
      <BackgroundErrorHeader />
      <BackgroundErrorPanel
        title="Something's not right!"
        isTitleUnderlined={true}
        message={
          <>
            The page you were looking for does not exist.
            <br />
            <br />
            For your company&apos;s tax guide, contact your manager.
            <br />
            <br />
            We sincerely apologize for the inconvenience.
          </>
        }
        imageSrc={bgImage}
        altText="Site Maintenance"
        backgroundBoxStyles={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: { xs: '50%', sm: '70%', md: '70%' },
        }}
        contentBoxStyles={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          padding: { xs: '20px', sm: '30px', md: '50px' },
          textAlign: 'center',
          maxWidth: { xs: '80%', sm: '60%', md: '30%' },
          maxHeight: 'auto',
          overflow: 'hidden',
        }}
      />
    </Box>
  );
};
